export default class SharePage {
    pageId: string;
    userId: string;
    constructor(id: string, userId: string) {
        this.pageId = id;
        this.userId = userId;
    }
}